export * from "./landing-page-tiles.component";
